// extracted by mini-css-extract-plugin
export default {"Promotion":"Promotion_Promotion__RptLe","Large":"Promotion_Large__JRJoL","Image":"Promotion_Image__Ky+Nw"};